export default "__VITE_ASSET__jvM1RA7n__"